const epr = {
  eprReport: "EPR declaration",
  country: "Jurisdiction",
  reportType: "EPR category",
  year: "Year",
  reportsEPR: "Reports EPR - Informes EPR",
  eprReporting: "EPR declarations",
  fillEPRHere: "Here you can fill your EPR declarations",
  fillEPRReport: "Fill EPR declaration",
  periodStart: "Period start",
  periodEnd: "Period end",
  totalSum: "Total amount",
  declaredQuantityKg: "Declared quantity (kg)",
  ecoFeeDue: "Eco-fee due",
  setEcoFeeDue: "Set Eco-fee due",
  addEPRReportToSeeData: "Add EPR report to see the data",
  addEPRReport: "Add EPR report",
  returnParameters: "Return parameters",
  editPackagingData: "Edit packaging data",
  summary: "Summary",
  name: "Name",
  glass: "Glass",
  paperPaperboardCardboard: "Paper/paperboard/cardboard",
  ferrousMetals: "Ferrous metals",
  aluminium: "Aluminium",
  plastic: "Plastic",
  beverageCartonPackaging: "Beverage carton packaging",
  otherCompositesPackaging: "Other Composites packaging",
  otherMaterials: "Other materials",
  paper: "Paper",
  steel: "Steel",
  wood: "Wood",
  numberOfScu: "Number of CSU",
  other: "Other",
  submit: "Submit",
  save: "Save",
  downloadReport: "Download report",
  back: "Back",
  warning: "Warning",
  furnitureEcoparticipations: "Furniture ecoparticipations",
  revenueExcludingVAT: "Revenue excluding VAT",
  code: "Code",
  tarifHT: "Tarif HT",
  tarifTTC: "Tarif TTC",
  codeEcopart: "Code Ecopart",
  number: "Number",
  summ: "Amount",
  category: "Category",
  product: "Product",
  material: "Material",
  feature: "Characteristic",
  addRecord: "Add Record",
  success: "Success",
  edit: "Edit",
  kg: "Kg",
  weight: "Weight",
  eprReportSuccessfullySubmitted: "EPR Report was successfully submitted!",
  eprReportSuccessfullyCreated: "EPR Report was successfully created!",
  cancel: "Cancel",
  delete: "Delete",
  areYouSureToDelete: "Are you sure you want to delete this item?",
  period: "Period",
  uploadTransactions: "Upload Transactions",
  submitDisclaimer:
    "By clicking on the Submit button you agree to the following: When you submit this EPR information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution.",
  transactionsUploadInProgress: "Transactions upload is still in progress!",
  confirmMoveForwardWithUnfinishedUpload:
    "I confirm that I want to move forward with EPR report filing with transactions upload process unfinished.",
  transactionsUploadInProgressMessage:
    "Transactions upload is in progress. It may take from 5 to 30 mins for it to finish depending on the amount of your transactions.",
  noActiveIntegration:
    'No active integration. Please complete an integration in "Stores" section to be able to upload your transactions.',
  yes: "Yes",
  no: "No",
  productTypologies: "Product typologies",
  productTypology: "Product typology",
  editTextileData: "Edit textile data",
  clothing: "Clothing",
  householdLinen: "Household linen",
  footwear: "Footwear",
  selectDeclarationMethod: "Available declaration methods",
  detailedDeclaration: "Detailed declaration",
  fourTypesOfReportingParameters:
    "4 types of reporting parameters for each item",
  volumesDeclaredPerProductLine: "Volumes declared per product line",
  standardScale: "Standard scale",
  simplifiedDeclaration: "Simplified declaration",
  twoStepsDeclaration: "2 steps declaration",
  volumesDeclaredPerProductFamily:
    "Volumes declared per product family (Clothing, Household linen, Footwear)",
  pricePerItemIncreased: "Price per item is increased",
  revenue: "Revenue",
  tax: "Tax",
  fee: "Fee",
  productDescription: "Product description",
  uploadPaymentMemo: "Upload payment memo file",
  quantity: 'Quantity',
  quantityIntegerOnly: "Only whole numbers allowed",
  fieldRequired: "This field is required",
  skip: "Skip",
  totalWeightKg: "Total weight (Kg)",
  quantityWithoutBreakdownNote: "Quantity – (without per-category breakdown for the Netherlands)",
  selectPackagingCategories: "Select packaging categories",
  guides: {
    subtitle: "Find instructions for filling EPR declarations by Jurisdiction.",
    searchPlaceholder: "Search Jurisdiction...",
    emptyState: "No guides found matching your search.",
    contactText: "Looking for something else?",
    contactLink: "Contact us",
    table: {
      country: "Jurisdiction",
      category: "Category",
      lastUpdated: "Last updated",
      language: "Language",
      action: "Action",
      viewPdf: "View PDF"
    }
  }
};

export default {
  ...epr,
  packagingSku: {
    pageTitle: "Packaging SKU",
    pageSubtitle: "Assign packaging types to product SKUs for EPR reporting.",
    menu: {
      products: "Packaging SKU",
      dashboard: "Dashboard",
      reports: "Reports",
      dataEditor: "Data editor",
      help: "Help",
    },
    placeholders: {
      productsTitle: "No SKUs yet",
      productsDescription: "Map packaging rules to products here — the same catalog as in the Shopify app, on Lappa.",
    },
    tabs: {
      primary: "Primary",
      shipping: "Shipping",
    },
    table: {
      id: "ID",
      name: "Name",
      type: "Type",
      weight: "Weight",
      length: "Length",
      height: "Height",
      width: "Width",
      actions: "Actions",
      status: "Status",
    },
    loadError: "Could not load packages.",
    actions: {
      edit: "Edit",
      delete: "Delete",
      changeStatus: "Change status",
      completeDraft: "Complete",
    },
    edit: {
      title: "Edit packaging",
      submit: "Save",
      saveError: "Could not update packaging.",
      loadError: "Could not load packaging.",
    },
    delete: {
      title: "Delete packaging",
      description: "Are you sure you want to delete {{name}}?",
      confirm: "Delete",
      cancel: "Cancel",
      error: "Could not delete packaging.",
      inUse: "This packaging is used by a label or a document request. Remove those first, then delete the packaging.",
    },
    access: {
      draftStatus: "A draft cannot change status. Publish the packaging by saving it. Status can be changed only after it is no longer a draft.",
      listForbidden: "You don't have access to the packaging list. Ask an admin for the products permission.",
      writeForbidden: "You don't have access to save packaging. Ask an admin for the EPR reports permission.",
      subscriptionRequired: "A subscription is required to save this packaging.",
    },
    filters: {
      search: "Search",
      searchPlaceholder: "Search by Packaging ID or name",
      status: "Status",
      store: "Store",
    },
    status: {
      title: "Change packaging status",
      select: "Status",
      placeholder: "Choose status",
      save: "Save",
      cancel: "Cancel",
      error: "Could not change status.",
    },
    add: {
      title: "Add packaging",
      submit: "Add packaging",
      cancel: "Cancel",
      name: "Name",
      namePlaceholder: "Enter packaging name",
      type: "Type",
      typePrimary: "Primary (product packaging)",
      typeShipping: "Shipping (transport packaging)",
      store: "Store",
      storePlaceholder: "Select store",
      weight: "Total weight",
      length: "Length",
      height: "Height",
      width: "Width",
      errorName: "Enter the packaging name.",
      errorNameLength: "Name must be 255 characters or fewer.",
      errorType: "Select the packaging type.",
      errorStore: "Select a store.",
      errorWeight: "Enter a weight greater than 0.",
      errorDimension: "Enter a value greater than 0.",
      saveError: "Could not create packaging.",
      activeDateHelper: "Optional. Clear the range to remove the dates.",
      chooseFormat: "Choose format",
      dateRange: "Date range",
      dimensionUnit: "Unit",
      errorIntendedEndUser: "Select the intended end user.",
      errorPackagingIdLength: "Packaging ID must be 255 characters or fewer.",
      formatDefaultHint: "Choose a format. The company is still using the system default.",
      formatExhaustedHint: "Choose another format.",
      formatSaveError: "Could not save the Packaging ID format.",
      formatScope: "The format is saved for the whole company.",
      formatsError: "Could not load Packaging ID formats.",
      nextIdError: "Could not load the next Packaging ID.",
      packagingId: "Packaging ID",
      packagingIdHelper: "Optional. The next free number is filled in. You can edit it or clear it.",
      packagingIdPlaceholder: "Packaging ID",
      skuTakenRefilled: "This Packaging ID was just taken. A new number is filled in. Save again.",
      storeShopifyHint: "A packaging without a store is not sent to Shopify. A draft is not sent either.",
      takeNextId: "Take next number",
      typeTabHint: "Shipping or Primary depends on the tab selected on the Packaging SKU page.",
      weightUnit: "Unit",
    },
    composition: {
      title: "Packaging composition",
      intro: "Add and describe all components that make up this packaging.",
      add: "Add packaging component",
      addComponent: "Add component",
      saveComponent: "Save component",
      component: "Component",
      generalProductCategory: "General product category",
      generalProductCategoryPlaceholder: "Select general product category",
      generalProductCategoryHelper: "Product type this packaging is used for (e.g. food, beverages).",
      category: "Category",
      categoryPlaceholder: "Select category",
      subcategory: "Subcategory {{number}}",
      subcategoryPlaceholder: "Select subcategory",
      categoryLoadError: "Could not load categories.",
      material: "Material",
      weight: "Weight",
      percent: "% of total",
      actions: "Actions",
      creation: "Component creation",
      manual: "Manual",
      aiAssisted: "AI Assisted",
      aiSuggestion: "AI suggestion",
      aiPlaceholder: "Select suggestion",
      componentType: "Component type",
      componentTypePlaceholder: "Select component type",
      customComponentType: "Custom component type",
      materialFamily: "Material family",
      materialFamilyPlaceholder: "Select material family",
      customMaterialFamily: "Custom material family",
      materialSubtype: "Material subtype",
      materialSubtypePlaceholder: "Select material subtype",
      rigidOrFlexible: "Rigid or flexible?",
      pcr: "Post-consumer recycled content (%)",
      bioBased: "Bio-based content (%)",
      biodegradable: "Is the plastic biodegradable?",
      compostable: "Is it compostable?",
      componentWeight: "Component weight",
      weightPlaceholder: "Weight",
      percentOfTotal: "Percentage of total packaging weight",
      separable: "Can the consumer separate this component?",
      selectOption: "Select option",
      recyclingCode: "Recycling Code",
      recyclingCodePlaceholder: "Select recycling codes",
      sortingInstruction: "Sorting Instruction",
      sortingInstructionPlaceholder: "Select sorting instruction",
      reusable: "Reusable or refillable",
      recycledDescription: "Recycled content description",
      recycledDescriptionPlaceholder: "Describe recycled content",
      recyclingStream: "Intended recycling stream",
      recyclingStreamPlaceholder: "Select recycling stream",
      notes: "Additional notes",
      notesPlaceholder: "Additional notes",
      addElement: "Add element",
      addMaterial: "Add material",
      addedMaterial: "Material {{number}}",
      composite: "Composite",
      multiLayer: "Multi-layer",
      deleteElement: "Delete element",
      detail: "Detail",
      detailNumbered: "Detail {{number}}",
      detailPlaceholder: "Select detail",
      editElement: "Edit element",
      editMaterial: "Edit material",
      emptyElements: "Choose packaging elements on the previous step, or add one here.",
      emptyElementsManual: "Add an element.",
      errorLayer: "Each added material needs a material and a weight.",
      errorMaterial: "Select a material.",
      errorWeight: "Enter the component weight.",
      howTo: "Click an element in the table to open its form. Fill in the component type, material and weight, then save. Added materials appear under that element.",
      incomplete: "Each element needs a material through the last level and a weight.",
      intendedEndUser: "Intended end user",
      intendedEndUserPlaceholder: "Select household or industrial",
      intendedEndUserRequired: "Select the intended end user on the Main step.",
      intendedEndUserRootMissing: "Household or industrial was not found in the category list.",
      intendedEndUser_household: "Household",
      intendedEndUser_industrial: "Industrial",
      componentType_main: "Main Component",
      componentType_separate: "Additional",
      loading: "Loading…",
      mainTransfer: "Choosing Main moves it from the current main element.",
      materialPlaceholder: "Select material",
      ready: "Ready",
      removeMaterial: "Remove material",
      save: "Save",
      structure: "Composite / Multi-layer",
      structureHelper: "Leave empty for one material, such as cardboard. Choose Composite or Multi-layer to add more materials, each with its own weight.",
      structurePlaceholder: "One material",
      subtype: "Subtype",
      subtypePlaceholder: "Select subtype",
    },
    formats: {
      alreadyAdded: "Already added",
      assign: "Click a picture",
      dropHint: "Drag packaging elements here or click them below. The first suitable element becomes the main component. Lids, labels, seals and similar parts stay additional.",
      element: "Element",
      errorDuplicate: "This packaging element is already added.",
      errorSeparateOnly: "This element can only be an additional component.",
      lockedHint: "Finish or cancel the current component to add another element.",
      main: "Main",
      mainMissing: "This packaging has no main element yet. The next suitable picture will become the main component.",
      mainRequired: "Lids, labels, seals and similar parts can only be additional. Add one main element, such as a box, bottle or bag.",
      paletteTitle: "Which elements make up this packaging?",
      pending: "Filling in",
      recommended: "recommended",
      remove: "Remove {{name}}",
      removeUnassigned: "Remove component without a picture",
      reorderHint: "Drag an element to the front to make it main. The one that leaves the first place becomes additional. Lids, labels and seals stay additional.",
      resourcePlural: "elements",
      resourceSingular: "element",
      separate: "Additional",
      suggestedMaterials: "Suggested materials: {{materials}}",
      unassigned: "No picture",
      box: "Box",
      tray: "Tray",
      bottle: "Bottle",
      jar: "Jar",
      can: "Can",
      bag: "Bag",
      tube: "Tube",
      cup: "Cup",
      lid: "Lid",
      label: "Label",
      pouch: "Pouch",
      film: "Film",
      blister: "Blister",
      pot: "Pot",
      beverage_carton: "Beverage carton",
      seal: "Seal",
      sleeve: "Sleeve",
      pump: "Pump",
      net: "Net",
      pallet: "Pallet",
      crate: "Crate",
      wrap: "Wrap",
      strap: "Strap",
      tape: "Tape",
      drum: "Drum",
      envelope: "Envelope",
      insert: "Insert",
    },
    wasteAttributes: {
      title: "Waste attributes",
      additionalSection: "Additional eco-modulation",
      reusablePackaging: "Reusable packaging",
      residualWaste: "Residual waste",
      isHazardous: "Is hazardous",
      beverage: "Beverage",
      recycled: "Recycled",
      uncoated: "Uncoated",
      nonCorrugated: "Non-corrugated",
      compostable: "Compostable packaging",
      depositReturnScheme: "Deposit return scheme (consigne)",
      postConsumerRecycledContentPercentage: "Post-consumer recycled content (%)",
      pcrHelper: "Share of post-consumer recycled material in the packaging.",
      errorPcr: "Enter a percentage between 0 and 100.",
      yes: "Yes",
      no: "No",
      clear: "Clear",
      emptyComponents: "Choose packaging elements, then fill in the composition to set eco modulation.",
      endOfLife: "End-of-life Recyclability",
      furtherSpecifications: "Select further specifications if applicable",
      furtherSpecificationsShort: "Further specifications",
      materialRequired: "Select a material type on the Packaging composition step.",
      recyclability: "Recyclability",
      recycledContent: "Recycled content",
      recycledContentPercentage: "Recycled content (%)",
      requiredInSomeCountries: "Required in some countries",
      select: "Select Waste Attributes",
      wasteAttributes: "Waste Attributes",
      single_use: "Single-use (most popular)",
      reusable: "Reusable",
      multi_use: "Multi-use",
      returnable: "Returnable",
      virginMaterial: "Virgin material",
      mono_material: "Mono-material",
      composite: "Composite",
      multi_layer: "Multi-layer",
      widelyRecyclable: "Widely Recyclable",
      endOfLifeCompostable: "Compostable",
      biodegradable: "Biodegradable",
      nonRecyclable: "Non-recyclable",
      non_corrugated: "Non-corrugated",
      clear_colourless: "Clear / colourless",
      green: "Green",
      brown_amber: "Brown / amber",
      mixed_dark: "Mixed dark",
      mixed_light: "Mixed light",
      other_colour: "Other colour",
      mixed_unknown: "Mixed / unknown",
      bottles_and_flasks: "Bottles and flasks",
      clear_transparent: "Clear transparent",
      coloured_transparent: "Coloured transparent",
      coloured_opaque: "Coloured opaque",
      coloured: "Coloured",
      transparent_colourless: "Transparent colourless",
      transparent_blue: "Transparent blue",
    },
    wizard: {
      createTitle: "Create packaging SKU",
      subtitle: "Add packaging details, dimensions, composition and waste attributes for EPR reporting.",
      backLabel: "Packaging SKU",
      back: "Back",
      next: "Next",
      skip: "Skip",
      stepsAriaLabel: "Packaging SKU wizard steps",
      draftShopifyHint: "A draft is not sent to Shopify.",
      saveDraft: "Save draft",
      saveDraftError: "Could not save the draft.",
      steps: {
        details: "Main",
        elements: "Packaging elements",
        composition: "Packaging composition",
        dimensions: "Dimensions",
        wasteAttributes: "Eco modulation",
        storeCategory: "Store & category",
        review: "Review & save",
      },
      stepDescriptions: {
        details: "Name, type and intended end user.",
        elements: "Choose the parts of this packaging.",
        composition: "Material, weight and component type.",
        dimensions: "Package dimensions.",
        wasteAttributes: "Waste attributes per component.",
        storeCategory: "Optional store and general product category.",
        review: "Review summary and save.",
      },
    },
    clone: {
      button: "Clone existing",
      title: "Clone packaging",
      description: "Search and select an existing packaging SKU to copy its details into this form.",
      searchLabel: "Packaging name",
      searchPlaceholder: "Search packaging...",
      empty: "No packaging items available to clone.",
      loadError: "Could not load packaging list.",
      selectError: "Could not load packaging details.",
      notFound: "Package not found",
    },
    guide: {
      title: "Component Types",
      tooltip: "Main, additional, and integrated components are categorized independently based on their dominant material by weight.",
      primaryAlt: "Primary packaging component types guide",
      shippingAlt: "Shipping packaging component types guide",
    },
  },
};
